import { Link } from "react-router-dom";
import React  from "react";
import "./Blog.css";
import Footer from "./Footer";

const Blog = () => {
  const articles = [
    {
      id: 1,
      image: "https://www.aleqt.com/sites/default/files/styles/scale_830/public/rbitem/2025/02/18/2431295-814220267.jpeg?itok=f_FUppUi",
      title: "أول مزاد لأراضي شمال الرياض بعد رفع الإيقاف.. بيع قطعتي أرض بـ710 ملايين ريال.",
      author: "Akari",
      date: "March 2025",
      description:
        "شهدت الأراضي الخام شمال مدينة الرياض، التي تم رفع الإيقاف عنها مؤخراً، أول ظهور للجمهور.",
        link:"https://www.aleqt.com/2025/02/18/article_2757332.html",
    },
    {
      id: 2,
      image: "https://www.aleqt.com/sites/default/files/styles/792x446_focalpoint/public/rbitem/2025/02/21/2431469-1933220485.jpeg?itok=wB_84ukO",
      title: "الشركة السعودية لإعادة التمويل العقاري تسعر أول صكوك لها بقيمة 2 مليار دولار",
      author: "Akari",
      date: "March 2025",
      description:
        "أتمت الشركة السعودية لإعادة التمويل العقاري، التابعة لصندوق الاستثمارات العامة، تسعير أول إصدار دولي للصكوك بضمان حكومي بقيمة 2 مليار دولار أمريكي (7.5 مليار ريال سعودي) على شريحتين بآجال استحقاق 3 و10 سنوات.",
        link:"https://www.aleqt.com/2025/02/18/article_2757332.html",
    },
    {
      id: 3,
      image: "https://www.aleqt.com/sites/default/files/styles/scale_830/public/rbitem/2025/02/27/2431858-1157295127.jpeg?itok=Y29wP51X",
      title: "اتفاقية تمويل عقاري توسع فرص تملك المواطنين للمساكن في السعودية",
      author: "ADMIN",
      date: "March 2025",
      description:
        "وقعت الشركة السعودية لإعادة التمويل العقاري، التابعة لصندوق الاستثمارات العامة، اتفاقية مع البنك الأهلي التجاري السعودي لشراء محفظة تمويل عقاري بقيمة 3.4 مليار ريال، في واحدة من أكبر عمليات إعادة التمويل العقاري في السعودية.",
        link:"https://www.aleqt.com/2025/02/18/article_2757332.html"
    },
    {
      id: 4,
      image: "https://www.aleqt.com/sites/default/files/styles/scale_830/public/rbitem/2025/03/16/2432902-1410021295.jpg?itok=b8maN32m",
      title: "السعودية تطلق خريطة معمارية بـ 19 طرازاً لتحسين المشهد الحضري وجودة الحياة",
      author: "Akari",
      date: "March 2025",
      description:
        "أطلقت السعودية اليوم خريطة معمارية تتضمن 19 نمطاً معمارياً مستوحاة من خصائص المملكة الجغرافية والثقافية، بهدف تحسين المشهد الحضري وجودة الحياة، وتعزيز التنمية الاقتصادية والناتج المحلي الإجمالي.",
        link:"https://www.aleqt.com/2025/03/16/article_2758587.html"
    },
    {
      id: 5,
      image: "https://www.aleqt.com/sites/default/files/styles/scale_830/public/rbitem/2025/03/20/2433137-336861407.jpeg?itok=ohytH2uY",
      title: "1.4 مليار ريال في «مناطق الخير 2» لتحقيق الاستقرار السكني لـ 8690 أسرة",
      author: "Akari",
      date: "March 2025",
      description:
        "جمعت حملة الخير 2 إجمالي 1.4 مليار ريال تبرعات واتفاقيات، مكنت الأسر وحققت استقراراً سكنياً لـ 8690 أسرة. وحظيت الحملة بدعم قيادي، حيث تبرع خادم الحرمين الشريفين الملك سلمان بن عبد العزيز بمبلغ 100 مليون ريال، وتبرع ولي العهد الأمير محمد بن سلمان رئيس مجلس الوزراء بمبلغ 50 مليون ريال",
        link:"https://www.aleqt.com/2025/03/20/article_2758786.html"
    },
    {
      id: 6,
      image: "https://www.aleqt.com/sites/default/files/styles/scale_830/public/rbitem/2025/03/21/2433214-1749525158.jpeg?itok=KkZMeUzc",
      title: "الكويت تستعد لفتح باب الرهون العقارية لأول مرة أمام البنوك",
      author: "Akari",
      date: "March 2025",
      description:
        "تستعد الكويت بالسماح للمصارف بتقديم الرهون العقارية لأول مرة، في خطوة قد تعيد تشكيل المشهد المالي في الدولة الغنية بالنفط",
        link:"https://www.aleqt.com/2025/03/21/article_2758847.html"
    },
    {
      id: 7,
      image: "https://www.aleqt.com/sites/default/files/styles/scale_830/public/rbitem/2025/03/20/2433147-142563486.png?itok=HMwdfAie",
      title: "«المهندسين» للمقاولات الاقتصادية: نعمل على تأهيل الكوادر الهندسية في العمارة السعودية.",
      author: "Akari",
      date: "March 2025",
      description:
        " تعتزم الهيئة السعودية للمهندسين تطبيق خريطة العمارة السعودية من خلال تدريب المكاتب والشركات الهندسية على مختلف الطرز المعمارية الـ 19 المعتمدة في المملكة سواء للمباني التجارية أو السكنية",
        link:"https://www.aleqt.com/2025/03/20/article_2758757.html",
    },
    {
      id: 8,
      image: "https://www.aleqt.com/sites/default/files/styles/scale_830/public/rbitem/2025/03/17/2432916-1717673369.jpeg?itok=rdD7NeqA",
      title: "أسعار المنازل في الصين تنخفض في أول تدهور لها منذ 6 أشهر",
      author: "Akari",
      date: "March 2025",
      description:
        "انخفضت أسعار المنازل في الصين بوتيرة سريعة في فبراير، مسجلة أول تدهور لها منذ 6 أشهر، على الرغم من الجهود الأخيرة التي بذلتها البلاد لدعم السوق",
        link:"https://www.aleqt.com/2025/03/17/article_2758596.html"
    },
    
 ];

  return (
    <>
    <div className="blog-container">
      <h2 className="blog-heading">أخبار ومقالات العقارات</h2>
      <p className="blog-subheading">كن على اطلاع دائم بأحدث أخبارنا ومقالاتنا</p>
      <div className="blog-grid">
        {articles.map((article) => (
          <div key={article.id} className="blog-card">
          <Link>
            <img src={article.image} alt={article.title} className="blog-image" />
            </Link>
            <div className="blog-content">
              <h3>{article.title}</h3>
              <p className="blog-meta">
                Posted By <span>{article.author}</span> | {article.date}
              </p>
              <p>{article.description}</p>
              <a href="">
                <button>Read More</button>
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
    <Footer/>
    </>
  );
};

export default Blog;

